<template>
  <sidebar-right @overlayClicked="outside" :class="[
    'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400',
    { open: show }
  ]">
    <div class="scrollbar-inner">
      <div class="card-header mt-0 d-flex align-items-center chat-header-title navbar-height bg-navy rounded-0">

        <div class="d-block">
          <div class="header-title">Timesheet<span class="bracket"> { </span></div>
        </div>



        <div class="d-block ml-auto">
          <div class="">
            <flat-picker @on-open="() => { }" @on-close="() => { }" @on-change="
              () => {
                // this.fetchAllRecords()
              }
            " :config="{ wrap: true, allowInput: false }" class="form-control datepicker" v-model="selectedDate">
            </flat-picker>
            <a @click="_onCalendarClicked"
              class="nav-link icon-shape icon-shape--26 icon-shape--white py-1 px-2 timesheet-icon" data-toggle
              data-original-title="Timesheet Entry" data-target="offcanvasTimer" data-offcanvasfrom="offcanvas">

              {{ formattedDate }}
              <i class="ml-2 ni ni-calendar-grid-58" style="font-size:20px"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body d-flex justify-content-end align-items-center">
          <!-- <label>Timesheet Type</label> -->
          <div class="d-flex justify-content-end">
            <base-button :type="entryMode == 'leave' ? 'primary' : 'outline'" @click="entryMode = 'leave'">Leave</base-button>
            <base-button :type="entryMode == 'projecttask' ? 'primary' : 'outline'"
              @click="entryMode = 'projecttask'">Project/Task</base-button>

          </div>
        </div>
        <hr class="mt-0 mb-0" />
        <div class="timesheetentryleave card-body" v-if="entryMode == 'leave'">
          <div class="form-group mb-3">
            <label class="form-control-label mb-0" for="exampleFormControlTextarea1">Leave Type</label>
          </div>
          <el-select v-model="selectedLeaveType" class="w-100 radius-0 mb-2" placeholder="Search Bracket Here" size="small"
            value-key="id" filterable>
            <el-option v-for="(leaveType, index) in ['Personal Leave', 'Sick Leave']" :value="leaveType"
              :label="leaveType" :key="index" class="select-danger" />
          </el-select>

          <div class="form-group mb-3">
            <label class="form-control-label mb-0" for="exampleFormControlTextarea1">Leave Duration</label>
          </div>
          <el-select v-model="selectedLeaveDuration" class="w-100 radius-0 mb-2" placeholder="Search Bracket Here" size="small"
            value-key="id" filterable>
            <el-option v-for="(ld, index) in selectedLeaveType=='Personal Leave'?['1st Half Day(PL)', '2nd Half Day(PL)', 'Full Day(PL)']:['1st Half Day(SL)', '2nd Half Day(SL)', 'Full Day(SHD)']" :value="ld"
              :label="ld" :key="index" class="select-danger" />
          </el-select>

          <button @click="handleLeaveEntry" type="button" class="btn btn-success btn-lg btn-block mt-3">
                     {{ isEdit ? 'Update': 'Submit'}} 
                    </button>
        </div>

        <div class="timesheetentrytask" v-if="entryMode == 'projecttask'">
          <div v-if="projects" class="card-body border mb-2 border-left-0 border-top-0 border-right-0 pb-3">
            <div class="form-group mb-3">
              <!-- <label class="form-control-label text-muted font-weight-normal mb-3" for="exampleFormControlTextarea1">Description
                of work completed, be
                short but accurate.</label> -->
              <label class="form-control-label mb-0" for="exampleFormControlTextarea1">Project#</label>
            </div>
            <el-select v-model="selectedProject" class="w-100 radius-0" placeholder="Search Bracket Here" size="small"
              value-key="id" filterable @change="_onProjectSelected">
              <el-option v-for="(project, index) in projects.data || []" :value="project" :label="project.name"
                :key="index" class="select-danger" />
            </el-select>
          </div>

          <div v-if="tasks && tasks.data" class="card-body border-left-0 border-top-0 border-right-0 pb-3 pt-0"
            :class="{ border: selectedTask }">
            <div class="form-group mb-3">
              <!-- <label class="form-control-label text-muted font-weight-normal mb-3" for="exampleFormControlTextarea1">Description
                of work completed, be
                short but accurate.</label> -->
              <label class="form-control-label mb-0" for="exampleFormControlTextarea1">Bracket#</label>
            </div>
            <el-select v-model="selectedTask" class="w-100 radius-0" placeholder="Search Task Here" size="small"
              filterable value-key="id">
              <el-option v-for="(task, index) in tasks.data" :value="task" :label="task.name" :key="index"
                class="select-danger" />
            </el-select>
          </div>
          <!-- Card body -->
          <div class="card-body" v-if="selectedTask">
            <div class="progress-label mb-3 justify-content-start">
              <span class="bg-dark text-white text-capitalize px-2" data-toggle="tooltip" data-placement="top" title=""
                data-original-title="5 out of 10 hours quoted on this Task">{{ taskBudget.workedHours }}/{{
                  taskBudget.hours
                }}</span>
              <span
                class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal">hours</span>
              <span class="bg-dark text-white text-capitalize px-2" data-toggle="tooltip" data-placement="top" title=""
                data-original-title="17 hours ($170) per hour = $17,000">{{ taskBudget.currency }}{{
                  taskBudget.cost
                }}</span>
              <span
                class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal">quoted
                on this Task</span>
            </div>
            <div v-if="selectedTask" class="progress-label mb-3 justify-content-start">
              <span class="bg-danger text-white text-capitalize px-2" data-toggle="tooltip" data-placement="top"
                title="" data-original-title="Project is 15 hours over quote">{{ projectBudget.workedHours }}/{{
                  projectBudget.hours
                }}</span>
              <span
                class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal">hours</span>
              <span class="bg-dark text-white text-capitalize px-2" data-toggle="tooltip" data-placement="top" title=""
                data-original-title="17 hours ($170) per hour = $17,000">{{ projectBudget.currency }}{{
                  projectBudget.cost
                }}</span>
              <span
                class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal">quoted
                on this Project</span>
            </div>
            <div v-if="selectedTask" class="progress-label mb-0 justify-content-start">
              <span class="bg-success text-white text-capitalize px-2" data-toggle="tooltip" data-placement="top"
                title="" data-original-title="Due Date">{{ deadline }}</span>
              <span
                class="badge bg-white text-default px-1 badge--font-size-per-76 text-lowercase font-weight-normal">deadline</span>
            </div>
          </div>
          <div v-if="false" class="card-body card-body  border-bottom-0 border-right-0 border-left-0"
            :class="{ border: selectedTask }">
            <form action="">
              <div class="form-group mb-3">
                <!-- <label class="form-control-label text-muted font-weight-normal mb-3" for="exampleFormControlTextarea1">Description
              of work completed, be
              short but accurate.</label> -->
                <label class="form-control-label mb-0" for="exampleFormControlTextarea1">You may like to extend this
                  quote</label>
              </div>
              <button type="button" class="btn btn-primary btn-sm" data-target="offcanvasChangerequest"
                data-offcanvasfrom="offcanvas">
                Change Request
              </button>
            </form>
          </div>

          <div class="card-body border-bottom-0 border-right-0 border-left-0 timer-block"
            :class="{ border: selectedTask }">
            <div class="timer-block__add">
              <a href="jaavascript:void(0);" class="btn btn-sm btn-info">Add Time</a>
              <a href="javascript:void(0);" @click="addTime(10)" class="btn btn-sm btn-outline-primary">Add 10</a>
              <a href="javascript:void(0);" @click="addTime(30)" class="btn btn-sm btn-outline-primary">Add 30</a>
              <a href="javascript:void(0);" @click="outside" class="btn btn-sm btn-warning float-right">My Timesheet</a>
              <!-- <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-primary">Add 10</button>
                  <button type="button" class="btn btn-primary">Add 30</button>
                  <button type="button" class="btn btn-primary">Add Time</button>
                </div> -->
            </div>
            <!-- <hr class="my-4"> -->
            <div class="timer-block__timer mt-4">
              <form action="">
                <div class="row align-items-center">
                  <div class="col">
                    <div class="form-group mb-3">
                      <label class="form-control-label" for="example-time-input-start">Start Time:</label>
                      <!-- <input
                      class="form-control form-control-sm"
                      type="time"
                      value="08:30:00"
                      id="example-time-input-start"
                    /> -->
                      <el-time-select style="width:150px" size="small" v-model="selectedStartTime" :picker-options="{
                        start: '08:30',
                        step: '00:15',
                        end: '18:30'
                      }" placeholder="Select time"
                      @change="onEndTimeSelect"
                      >
                      
                      </el-time-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group mb-3">
                      <label class="form-control-label" for="example-time-input-end">End Time:</label>
                      <el-time-select style="width:150px" size="small" @change="onEndTimeSelect"
                        v-model="selectedEndTime" :picker-options="{
                          start: '08:30',
                          step: '00:15',
                          end: '18:30'
                        }" placeholder="Select time">
                      </el-time-select>
                    </div>
                  </div>
                </div>

                <div class="row align-items-center">
                  <div class="col">
                    <div class="form-group mb-1">
                      <label class="form-control-label" for="example-number-input-hours">Hours:</label>
                      <!-- <input class="form-control form-control-sm" type="number" value="23" id="example-number-input-hours"> -->
                      <select v-model="selectedHour" class="form-control form-control-sm"
                        id="exampleFormControlSelect1">
                        <option>0</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                        <option>11</option>
                        <option>12</option>
                        <option>13</option>
                        <option>14</option>
                        <option>15</option>
                        <option>16</option>
                        <option>17</option>
                        <option>18</option>
                        <option>19</option>
                        <option>20</option>
                        <option>21</option>
                        <option>22</option>
                        <option>23</option>
                        <option>24</option>
                      </select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group mb-1">
                      <label class="form-control-label" for="example-number-input-hours">Minutes:</label>
                      <input v-model="selectedMinute" class="form-control form-control-sm" type="number" value="23"
                        id="example-number-input-hours" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group mt-3 ">
                      <!-- <label class="form-control-label text-muted font-weight-normal mb-3" for="exampleFormControlTextarea1">Description
                        of work completed, be
                        short but accurate.</label> -->
                      <label class="form-control-label mb-3" for="exampleFormControlTextarea1">Work completed on this
                        task</label>
                      <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                        v-model="selectedDescription"></textarea>
                    </div>
                    <button @click="handleRegistration" type="button" class="btn btn-success btn-lg btn-block">
                     {{ isEdit ? 'Update': 'Submit'}} 
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </sidebar-right>
</template>
<script>
import Logo from "./Logo.vue";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import {
  required,
  minLength,
  between,
  email,
  sameAs
} from "vuelidate/lib/validators";
import SidebarRight from "../layout/SidebarRight.vue";
import moment from "moment";
import flatPicker from "vue-flatpickr-component";

export default {
  props: ["show", "fullWidth", "timesheet", "clickedDate"],
  components: { Logo, SidebarRight, flatPicker },
  name: "TimelineEdit",
  data() {
    return {
      code: "",
      selectedTask: null,
      selectedProject: null,
      selectedStartTime: null,
      selectedEndTime: null,
      selectedDate: this.clickedDate,
      selectedHour: 0,
      selectedMinute: 15,
      selectedDescription: null,
      entryMode: 'projecttask',
      selectedLeaveType: null,
      selectedLeaveDuration: null,
      isEdit: false,
      timeSheetId: null
    };
  },
  validations: {
    code: {
      required
    }
  },
  watch: {
    timesheet: function (newVal, oldVal) { // watch it
      console.log('data  changed: ', newVal, ' | was: ', oldVal)
      this.selectedTask = newVal.task
      this.selectedProject = newVal.project
      this._onProjectSelected()
      this.selectedEndTime = moment(this.timesheet.end_date).format("HH:mm"),
      this.selectedStartTime = moment(this.timesheet.start_date).format("HH:mm")
      this.selectedDescription = this.timesheet.description
      this.isEdit = this.timesheet != null
      this.timeSheetId = this.timesheet.id
      this.onEndTimeSelect()
    }
  },
  computed: {
    ...mapState("user", ["registrationData", "profile"]),
    ...mapState("project", ["projects", "archievedProjects"]),
    ...mapState("task", ["tasks"]),


    formattedDate() {
      return moment(this.selectedDate).format('yyyy-MM-DD')
    },
    usersDataAsString() {
      return JSON.stringify(this.registrationData);
    },

    taskBudget() {
      let totalHours = 0;
      let workedSeconds = 0;
      let totalCost = 0;
      let t = this.selectedTask;

      let tc = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
      totalHours = parseInt(t.quoted_hours || 0);
      workedSeconds = parseInt(t.total_seconds || 0);
      const dp = isNaN(parseInt(t.discount_percentage))
        ? 0
        : parseInt(t.discount_percentage);
      const numOfDays = parseInt(t.no_of_days || 1);
      //totalCost = (tc - (tc * dp) / 100) * numOfDays;
      //totalCost += (tc - (tc * dp) / 100);
      totalCost += tc;
      //totalCost = totalCost.toFixed(2);
      console.log(dp, t.no_of_days, "project budget");

      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      } else {
        totalCost = totalCost.toFixed(2);
      }

      return {
        currency: this.profile && this.profile.currency.symbol,
        hours: totalHours,
        cost: totalCost,
        workedHours: (workedSeconds / 3600).toFixed(0)
      };
    },

    deadline() {
      return moment(this.selectedTask.deadline).format("lll");
    },

    projectBudget() {
      let totalHours = 0;
      let workedSeconds = 0;
      let totalCost = 0;
      let tasks = (this.tasks && this.tasks.data) || [];

      tasks.map(t => {
        let tc = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
        totalHours = parseInt(t.quoted_hours || 0);
        workedSeconds += parseInt(t.total_seconds || 0);
        const dp = isNaN(parseInt(t.discount_percentage))
          ? 0
          : parseInt(t.discount_percentage);
        const numOfDays = parseInt(t.no_of_days || 1);
        const teamSize = parseInt(t.total_team_members || 1);
        //totalCost += (tc - (tc * dp) / 100);
        totalCost += tc;
        //totalCost = totalCost.toFixed(2);
        console.log(dp, t.no_of_days, "project budget");
      });

      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      } else {
        totalCost = totalCost.toFixed(2);
      }

      return {
        currency: this.profile && this.profile.currency.symbol,
        hours: totalHours,
        cost: totalCost,
        workedHours: (workedSeconds / 3600).toFixed(0)
      };
    }
  },

  async mounted() {

    let curMin = moment().get('minutes')
    let newMinuteFactor = Math.ceil(curMin / 5);
    let curDate = moment().set('minute', newMinuteFactor * 5)
    this.selectedStartTime = curDate.format("HH:mm")


    this.selectedEndTime = curDate.add(15, 'minutes').format("HH:mm")

    try {
      await this.fetchAllProjects();
      this.setLoading(false);
    } catch (e) { }
  },

  methods: {
    ...mapMutations(["setLoading"]),
    ...mapActions("user", ["performUserVerification"]),
    ...mapActions("project", ["fetchAllProjects"]),
    ...mapActions("task", ["fetchAllTasksByProjectId"]),
    ...mapActions("timesheet", ["createTimesheetEntry", "createLeaveEntry", "updateTimesheetEntry"]),

    async _onProjectSelected() {
      console.log(this.selectedProject);
      try {
        this.setLoading(true);
        await this.fetchAllTasksByProjectId(this.selectedProject.id);
        this.setLoading(false);
      } catch (e) { }
    },

    _onCalendarClicked() {
      //this.$emit('calendarClicked')
    },

    addTime(mins) {
      let start = moment(moment(


        this.selectedDate).format("yyyy-MM-DD") + " " + this.selectedStartTime)
      this.selectedEndTime = start.add(mins, 'minutes').format("HH:mm")
      this.onEndTimeSelect()
    },

    onEndTimeSelect() {
      let start = moment(moment(this.selectedDate).format("yyyy-MM-DD") + " " + this.selectedStartTime)
      let end = moment(moment(this.selectedDate).format("yyyy-MM-DD") + " " + this.selectedEndTime)
      if (start.isAfter(end)) {
        this.$snack.success("Start time can not be greater than end");
        return
      }

      let duration = moment.duration(end.diff(start));
      let hours = duration.asHours();
      let mins = duration.asMinutes()

      this.selectedHour = parseInt(hours)
      this.selectedMinute = mins - (this.selectedHour * 60)

      console.log("hours ", this.selectedHour);
      console.log("minutes ", this.selectedMinute, mins);
    },


    async handleRegistration() {
      let start = moment(moment(this.selectedDate).format("yyyy-MM-DD") + " " + this.selectedStartTime)
      let end = moment(moment(this.selectedDate).format("yyyy-MM-DD") + " " + this.selectedEndTime)
      if (start.isAfter(end)) {
        this.$snack.success("Start time can not be greater than end");
        return
      }
      if (!this.selectedProject) {
        this.$snack.success("Please select project");
        return
      }

      if (!this.selectedTask) {
        this.$snack.success("Please select task");
        return
      }


      if (!this.selectedStartTime || this.selectedEndTime == null || this.selectedHour == null || this.selectedMinute == null) {
        this.$snack.success("Please define times");
        return
      }

      if (!this.selectedDescription) {
        this.$snack.success("Please type description of work");
        return
      }

      // utc().format('yyyy-MM-DD hh:mm:ss')

      let body = {
        start_date: start.utc().format('yyyy-MM-DD hh:mm:ss'),
        end_date: end.utc().format('yyyy-MM-DD hh:mm:ss'),
        project_id: this.selectedProject.id,
        task_id: this.selectedTask.id,
        description: this.selectedDescription,
        timesheet_id: this.timeSheetId
      }

      try {

        if(!this.isEdit){
           let res = await this.createTimesheetEntry(body)
           this.$snack.success("Timesheet successfully added");
          this.$emit("timesheetCreated");
        }else{
            let res = await this.updateTimesheetEntry(body)
            this.$snack.success("Timesheet updated successfully");
           this.$emit("timesheetUpdated");
        }
      

        this.outside()
      } catch (error) {
        console.log("Update timesheet error", error)
        this.$snack.success("Could not create timesheet entry");
      }

    },

   async handleLeaveEntry() {
    console.log(this.selectedTask)
       let body = {
        leave_type: this.selectedLeaveType,
        duration_type: this.selectedLeaveDuration
      }
      let res = await this.createLeaveEntry(body)
    },

    outside() {
      this.$emit("outSideClicked");
    }
  }
};
</script>
